<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    no-close-on-backdrop
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-row>
        <b-col>
          <label tag="div">Motivo: </label>
          <multiselect
            v-model="parmotId"
            :options="this.$parent.$parent.$parent.optionsParamMotivo"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder=""
            select-label=""
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            v-text="form.errors.get('cd_ocorrencia')"
            v-if="form.errors.has('cd_ocorrencia')"
          ></b-form-feedback>
        </b-col>
      </b-row>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: ""
  },
  data() {
    return {
      dataExport: [],
      parmotId: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      showPopover: false,
      statusSelected: [],
      mascaraDia: "##/##/#### ##:##",
      optionsCodOcorrencia: [],
      errors_array: [],
      data: [],
      form: new Form({
        carocorren_id: "",
        parmot_id: "",
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  watch: {
    parmotId(obj) {
      this.form.parmot_id = obj.value;
    }
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.feriado_id);
      }
    },
    onCreate(data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.errors_array = "";
      this.errors_array = [];
      this.parmotId = [];
      this.form.reset();
      this.form.carocorren_id = data;
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.municipioSelected = [];
      this.ufSelected = [];
      this.tpFeriadoSelected = [];
      this.form.feriado_id = data.feriado_id;
      this.form.ano = data.ano;
      this.form.diaMes = data.dia + "/" + data.mes;
      this.form.descr = data.descr;
      this.form.status = data.status.valor;
      this.form.feriado_anual = data.feriado_anual.valor;
      this.tpFeriadoSelected = {
        label: data.tp_feriado.descr,
        value: data.tp_feriado.valor
      };
      if (data.rel_feriado_uf != null) {
        this.ufSelected = {
          label: data.rel_feriado_uf.uf.nome,
          value: data.rel_feriado_uf.uf.uf_id
        };
      }
      if (data.rel_feriado_municipio != null) {
        this.ufSelected = {
          label: data.rel_feriado_municipio.municipio.uf.nome,
          value: data.rel_feriado_municipio.municipio.uf.uf_id
        };
        this.municipioSelected = {
          label: data.rel_feriado_municipio.municipio.nome,
          value: data.rel_feriado_municipio.municipio.municipio_id
        };
      }
      this.tpFeriadoSelected = {
        label: data.tp_feriado.descr,
        value: data.tp_feriado.valor
      };
      this.form.param_id = id;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;      
      this.form
        .post("/api/inclusaoocorrencia/cancelamento/store")
        .then(response => {
          new ReturnApi(response, this, null, false);
          Vue.nextTick(() => this.$refs.vuetable.refresh());
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      console.log(id);
      this.form
        .patch("/api/feriado/update/" + id)
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/feriado/status")
        .then(response => {
          new ReturnApi(response, this);

          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
